export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";

export const CREATE_ADMIN = "CREATE_ADMIN";
export const RETRIEVE_ADMINS = "RETRIEVE_ADMINS";
export const UPDATE_ADMIN = "UPDATE_ADMIN";
export const DELETE_ADMIN = "DELETE_ADMIN";
export const serverType = "SET_SERVER_TYPE";
